// extracted by mini-css-extract-plugin
export default {"dragToScrollCpn":"dragToScroll_dragToScrollCpn__wjS3E","btnCircle":"dragToScroll_btnCircle__oJ6lM","prev":"dragToScroll_prev__ee7uQ","next":"dragToScroll_next__9JwDC"};